/* tslint:disable */
/* eslint-disable */
/**
 * SJTU-MEM-BE
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AuthorizeLoginParams
 */
export interface AuthorizeLoginParams {
    /**
     * 
     * @type {string}
     * @memberof AuthorizeLoginParams
     */
    'username'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AuthorizeLoginParams
     */
    'password'?: string | null;
}
/**
 * 
 * @export
 * @interface CreateSubmissionModel
 */
export interface CreateSubmissionModel {
    /**
     * 
     * @type {number}
     * @memberof CreateSubmissionModel
     */
    'termId': number;
    /**
     * 
     * @type {string}
     * @memberof CreateSubmissionModel
     */
    'title': string;
}
/**
 * 
 * @export
 * @interface ExcelExportResponse
 */
export interface ExcelExportResponse {
    /**
     * 
     * @type {string}
     * @memberof ExcelExportResponse
     */
    'url'?: string | null;
}
/**
 * 
 * @export
 * @interface ExcelImportResponse
 */
export interface ExcelImportResponse {
    /**
     * 
     * @type {string}
     * @memberof ExcelImportResponse
     */
    'errorMessage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExcelImportResponse
     */
    'errorExcelUrl'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ExcelImportResponse
     */
    'addCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ExcelImportResponse
     */
    'passCount'?: number;
}
/**
 * 
 * @export
 * @interface FindParams
 */
export interface FindParams {
    /**
     * 
     * @type {number}
     * @memberof FindParams
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface GetExcelTemplateResponse
 */
export interface GetExcelTemplateResponse {
    /**
     * 
     * @type {string}
     * @memberof GetExcelTemplateResponse
     */
    'url'?: string | null;
}
/**
 * 
 * @export
 * @interface SaveTermModel
 */
export interface SaveTermModel {
    /**
     * 
     * @type {string}
     * @memberof SaveTermModel
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SaveTermModel
     */
    'beginTime': string;
    /**
     * 
     * @type {string}
     * @memberof SaveTermModel
     */
    'endTime': string;
    /**
     * 
     * @type {TermStatus}
     * @memberof SaveTermModel
     */
    'status': TermStatus;
    /**
     * 
     * @type {number}
     * @memberof SaveTermModel
     */
    'id'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveTermModel
     */
    'isUpdate'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SaveTermModel
     */
    'isAdd'?: boolean;
}


/**
 * 
 * @export
 * @interface StudentUpdateInfoModel
 */
export interface StudentUpdateInfoModel {
    /**
     * 
     * @type {number}
     * @memberof StudentUpdateInfoModel
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof StudentUpdateInfoModel
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof StudentUpdateInfoModel
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof StudentUpdateInfoModel
     */
    'telephone': string;
    /**
     * 
     * @type {string}
     * @memberof StudentUpdateInfoModel
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof StudentUpdateInfoModel
     */
    'school': string;
    /**
     * 
     * @type {string}
     * @memberof StudentUpdateInfoModel
     */
    'grade': string;
    /**
     * 
     * @type {number}
     * @memberof StudentUpdateInfoModel
     */
    'teacherId': number;
    /**
     * 
     * @type {string}
     * @memberof StudentUpdateInfoModel
     */
    'thesisStartReport'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StudentUpdateInfoModel
     */
    'thesisMiddleReport'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StudentUpdateInfoModel
     */
    'thesisReady'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StudentUpdateInfoModel
     */
    'thesisOk'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StudentUpdateInfoModel
     */
    'gpa'?: string | null;
}
/**
 * 
 * @export
 * @interface SubmissionAuditCheckerModel
 */
export interface SubmissionAuditCheckerModel {
    /**
     * 
     * @type {boolean}
     * @memberof SubmissionAuditCheckerModel
     */
    'isPassed': boolean;
    /**
     * 
     * @type {string}
     * @memberof SubmissionAuditCheckerModel
     */
    'remark'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SubmissionAuditCheckerModel
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface SubmissionAuditJudgerModel
 */
export interface SubmissionAuditJudgerModel {
    /**
     * 
     * @type {number}
     * @memberof SubmissionAuditJudgerModel
     */
    'score01': number;
    /**
     * 
     * @type {number}
     * @memberof SubmissionAuditJudgerModel
     */
    'score02': number;
    /**
     * 
     * @type {number}
     * @memberof SubmissionAuditJudgerModel
     */
    'score03': number;
    /**
     * 
     * @type {number}
     * @memberof SubmissionAuditJudgerModel
     */
    'score04': number;
    /**
     * 
     * @type {number}
     * @memberof SubmissionAuditJudgerModel
     */
    'score05': number;
    /**
     * 
     * @type {string}
     * @memberof SubmissionAuditJudgerModel
     */
    'remark': string;
    /**
     * 
     * @type {string}
     * @memberof SubmissionAuditJudgerModel
     */
    'advice'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SubmissionAuditJudgerModel
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface SubmissionAuditSupervisorModel
 */
export interface SubmissionAuditSupervisorModel {
    /**
     * 
     * @type {SubmissionAuditSupervisorResult}
     * @memberof SubmissionAuditSupervisorModel
     */
    'result': SubmissionAuditSupervisorResult;
    /**
     * 
     * @type {string}
     * @memberof SubmissionAuditSupervisorModel
     */
    'remark': string;
    /**
     * 
     * @type {number}
     * @memberof SubmissionAuditSupervisorModel
     */
    'id'?: number;
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum SubmissionAuditSupervisorResult {
    需修改 = '需修改',
    不通过 = '不通过',
    通过 = '通过'
}


/**
 * 
 * @export
 * @interface SubmissionDeletePaperModel
 */
export interface SubmissionDeletePaperModel {
    /**
     * 
     * @type {number}
     * @memberof SubmissionDeletePaperModel
     */
    'paperId': number;
    /**
     * 
     * @type {number}
     * @memberof SubmissionDeletePaperModel
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface SubmissionDistributeCheckerModel
 */
export interface SubmissionDistributeCheckerModel {
    /**
     * 
     * @type {number}
     * @memberof SubmissionDistributeCheckerModel
     */
    'checkerId': number;
    /**
     * 
     * @type {number}
     * @memberof SubmissionDistributeCheckerModel
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface SubmissionDistributeJudgerModel
 */
export interface SubmissionDistributeJudgerModel {
    /**
     * 
     * @type {number}
     * @memberof SubmissionDistributeJudgerModel
     */
    'judgerId': number;
    /**
     * 
     * @type {number}
     * @memberof SubmissionDistributeJudgerModel
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface SubmissionDistributeSupervisorModel
 */
export interface SubmissionDistributeSupervisorModel {
    /**
     * 
     * @type {number}
     * @memberof SubmissionDistributeSupervisorModel
     */
    'supervisorId': number;
    /**
     * 
     * @type {number}
     * @memberof SubmissionDistributeSupervisorModel
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface SubmissionDto
 */
export interface SubmissionDto {
    /**
     * 
     * @type {number}
     * @memberof SubmissionDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof SubmissionDto
     */
    'createdTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubmissionDto
     */
    'deletedTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubmissionDto
     */
    'restoredTime'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SubmissionDto
     */
    'isDelete'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SubmissionDto
     */
    'title'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SubmissionDto
     */
    'userId'?: number;
    /**
     * 
     * @type {UserDto}
     * @memberof SubmissionDto
     */
    'user'?: UserDto;
    /**
     * 
     * @type {number}
     * @memberof SubmissionDto
     */
    'teacherId'?: number;
    /**
     * 
     * @type {UserDto}
     * @memberof SubmissionDto
     */
    'teacher'?: UserDto;
    /**
     * 
     * @type {number}
     * @memberof SubmissionDto
     */
    'supervisorId'?: number | null;
    /**
     * 
     * @type {UserDto}
     * @memberof SubmissionDto
     */
    'supervisor'?: UserDto;
    /**
     * 
     * @type {string}
     * @memberof SubmissionDto
     */
    'supervisorAuditedTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubmissionDto
     */
    'supervisorAuditedRemark'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SubmissionDto
     */
    'checkerId'?: number | null;
    /**
     * 
     * @type {UserDto}
     * @memberof SubmissionDto
     */
    'checker'?: UserDto;
    /**
     * 
     * @type {string}
     * @memberof SubmissionDto
     */
    'checkerAuditedTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubmissionDto
     */
    'checkerAuditedRemark'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubmissionDto
     */
    'checkerResubmitExpiredTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubmissionDto
     */
    'checkerExpiredTime'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SubmissionDto
     */
    'supervisorConclusion'?: number;
    /**
     * 
     * @type {number}
     * @memberof SubmissionDto
     */
    'judgeConclusion'?: number;
    /**
     * 
     * @type {string}
     * @memberof SubmissionDto
     */
    'supervisorExpiredTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubmissionDto
     */
    'supervisorResubmitExpiredTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubmissionDto
     */
    'judgeResubmitExpiredTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubmissionDto
     */
    'judgeExpiredTime'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SubmissionDto
     */
    'superviseSubmitCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof SubmissionDto
     */
    'judgeSubmitCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof SubmissionDto
     */
    'judgeId'?: number | null;
    /**
     * 
     * @type {UserDto}
     * @memberof SubmissionDto
     */
    'judge'?: UserDto;
    /**
     * 
     * @type {string}
     * @memberof SubmissionDto
     */
    'judgeAuditedTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubmissionDto
     */
    'judgeAuditedRemark'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubmissionDto
     */
    'judgeAuditedAdvice'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SubmissionDto
     */
    'score01'?: number;
    /**
     * 
     * @type {number}
     * @memberof SubmissionDto
     */
    'score02'?: number;
    /**
     * 
     * @type {number}
     * @memberof SubmissionDto
     */
    'score03'?: number;
    /**
     * 
     * @type {number}
     * @memberof SubmissionDto
     */
    'score04'?: number;
    /**
     * 
     * @type {number}
     * @memberof SubmissionDto
     */
    'score05'?: number;
    /**
     * 
     * @type {number}
     * @memberof SubmissionDto
     */
    'totalScore'?: number;
    /**
     * 
     * @type {number}
     * @memberof SubmissionDto
     */
    'termId'?: number;
    /**
     * 
     * @type {Term}
     * @memberof SubmissionDto
     */
    'term'?: Term;
    /**
     * 
     * @type {SubmissionStatus}
     * @memberof SubmissionDto
     */
    'status'?: SubmissionStatus;
    /**
     * 
     * @type {string}
     * @memberof SubmissionDto
     */
    'submittedTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubmissionDto
     */
    'teacherAuditedTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubmissionDto
     */
    'teacherAuditedRemark'?: string | null;
    /**
     * 
     * @type {Array<SubmissionLog>}
     * @memberof SubmissionDto
     */
    'logs'?: Array<SubmissionLog> | null;
    /**
     * 
     * @type {Array<SubmissionPaper>}
     * @memberof SubmissionDto
     */
    'papers'?: Array<SubmissionPaper> | null;
    /**
     * 
     * @type {Array<SubmissionPaper>}
     * @memberof SubmissionDto
     */
    'supervisorPapers'?: Array<SubmissionPaper> | null;
    /**
     * 
     * @type {Array<SubmissionPaper>}
     * @memberof SubmissionDto
     */
    'judgePapers'?: Array<SubmissionPaper> | null;
}


/**
 * 
 * @export
 * @interface SubmissionLog
 */
export interface SubmissionLog {
    /**
     * 
     * @type {string}
     * @memberof SubmissionLog
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubmissionLog
     */
    'remark'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SubmissionLog
     */
    'submissionId'?: number;
    /**
     * 
     * @type {number}
     * @memberof SubmissionLog
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof SubmissionLog
     */
    'createdTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubmissionLog
     */
    'deletedTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubmissionLog
     */
    'restoredTime'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SubmissionLog
     */
    'isDelete'?: boolean;
}
/**
 * 
 * @export
 * @interface SubmissionPaper
 */
export interface SubmissionPaper {
    /**
     * 
     * @type {string}
     * @memberof SubmissionPaper
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubmissionPaper
     */
    'path'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SubmissionPaper
     */
    'isJudgeVersion'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SubmissionPaper
     */
    'submissionId'?: number;
    /**
     * 
     * @type {string}
     * @memberof SubmissionPaper
     */
    'url'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SubmissionPaper
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof SubmissionPaper
     */
    'createdTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubmissionPaper
     */
    'deletedTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubmissionPaper
     */
    'restoredTime'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SubmissionPaper
     */
    'isDelete'?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum SubmissionStatus {
    待导师审核 = '待导师审核',
    导师审核需修改 = '导师审核需修改',
    待上传论文 = '待上传论文',
    待分配督导 = '待分配督导',
    待督导审批 = '待督导审批',
    督导审批需修改 = '督导审批需修改',
    督导审批不通过 = '督导审批不通过',
    待上传盲审论文 = '待上传盲审论文',
    待分配盲审 = '待分配盲审',
    待盲审审批 = '待盲审审批',
    盲审审批需修改 = '盲审审批需修改',
    盲审审批不通过 = '盲审审批不通过',
    申请完成 = '申请完成',
    待分配论文初审 = '待分配论文初审',
    待论文初审 = '待论文初审',
    待重新上传督导论文 = '待重新上传督导论文',
    论文初审不通过 = '论文初审不通过'
}


/**
 * 
 * @export
 * @interface TeacherAuditModel
 */
export interface TeacherAuditModel {
    /**
     * 
     * @type {number}
     * @memberof TeacherAuditModel
     */
    'id': number;
    /**
     * 
     * @type {boolean}
     * @memberof TeacherAuditModel
     */
    'isPassed': boolean;
    /**
     * 
     * @type {string}
     * @memberof TeacherAuditModel
     */
    'remark'?: string | null;
}
/**
 * 
 * @export
 * @interface Term
 */
export interface Term {
    /**
     * 
     * @type {string}
     * @memberof Term
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Term
     */
    'beginTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof Term
     */
    'endTime'?: string;
    /**
     * 
     * @type {TermStatus}
     * @memberof Term
     */
    'termStatus'?: TermStatus;
    /**
     * 
     * @type {number}
     * @memberof Term
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof Term
     */
    'createdTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof Term
     */
    'deletedTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Term
     */
    'restoredTime'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Term
     */
    'isDelete'?: boolean;
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum TermStatus {
    未开始 = '未开始',
    进行中 = '进行中',
    已结束 = '已结束'
}


/**
 * 
 * @export
 * @interface Token
 */
export interface Token {
    /**
     * 
     * @type {string}
     * @memberof Token
     */
    'body'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Token
     */
    'userId'?: number;
    /**
     * 
     * @type {string}
     * @memberof Token
     */
    'expiredTime'?: string;
    /**
     * 
     * @type {User}
     * @memberof Token
     */
    'user'?: User;
    /**
     * 
     * @type {number}
     * @memberof Token
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof Token
     */
    'createdTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof Token
     */
    'deletedTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Token
     */
    'restoredTime'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Token
     */
    'isDelete'?: boolean;
}
/**
 * 
 * @export
 * @interface UpdateSubmissionTermModel
 */
export interface UpdateSubmissionTermModel {
    /**
     * 
     * @type {number}
     * @memberof UpdateSubmissionTermModel
     */
    'termId': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateSubmissionTermModel
     */
    'id': number;
}
/**
 * 
 * @export
 * @interface User
 */
export interface User {
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'username'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'password'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'telephone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'school'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'grade'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'isJudge'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'isSupervisor'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'isChecker'?: boolean;
    /**
     * 
     * @type {UserRole}
     * @memberof User
     */
    'role'?: UserRole;
    /**
     * 
     * @type {number}
     * @memberof User
     */
    'teacherId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'thesisStartReport'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'thesisMiddleReport'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'thesisReady'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'thesisOk'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'gpa'?: string | null;
    /**
     * 
     * @type {User}
     * @memberof User
     */
    'teacher'?: User;
    /**
     * 
     * @type {number}
     * @memberof User
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'createdTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'deletedTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'restoredTime'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'isDelete'?: boolean;
}


/**
 * 
 * @export
 * @interface UserDto
 */
export interface UserDto {
    /**
     * 
     * @type {number}
     * @memberof UserDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'username'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'telephone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'school'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'grade'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserDto
     */
    'isJudge'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserDto
     */
    'isSupervisor'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserDto
     */
    'isChecker'?: boolean;
    /**
     * 
     * @type {UserRole}
     * @memberof UserDto
     */
    'role'?: UserRole;
    /**
     * 
     * @type {number}
     * @memberof UserDto
     */
    'teacherId'?: number | null;
    /**
     * 
     * @type {UserDto}
     * @memberof UserDto
     */
    'teacher'?: UserDto;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'thesisStartReport'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'thesisMiddleReport'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'thesisReady'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'thesisOk'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'gpa'?: string | null;
}


/**
 * 
 * @export
 * @interface UserFindParams
 */
export interface UserFindParams {
    /**
     * 
     * @type {number}
     * @memberof UserFindParams
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface UserGetDefaultPasswordParams
 */
export interface UserGetDefaultPasswordParams {
    /**
     * 
     * @type {string}
     * @memberof UserGetDefaultPasswordParams
     */
    'email': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum UserRole {
    管理员 = '管理员',
    学生 = '学生',
    教师 = '教师'
}


/**
 * 
 * @export
 * @interface UserToggleTeacherTypeModel
 */
export interface UserToggleTeacherTypeModel {
    /**
     * 
     * @type {number}
     * @memberof UserToggleTeacherTypeModel
     */
    'id': number;
    /**
     * 
     * @type {boolean}
     * @memberof UserToggleTeacherTypeModel
     */
    'isSupervisor': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserToggleTeacherTypeModel
     */
    'isChecker': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserToggleTeacherTypeModel
     */
    'isJudge': boolean;
}
/**
 * 
 * @export
 * @interface UserUpdatePasswordModel
 */
export interface UserUpdatePasswordModel {
    /**
     * 
     * @type {number}
     * @memberof UserUpdatePasswordModel
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof UserUpdatePasswordModel
     */
    'password': string;
}

/**
 * AuthorizeApi - axios parameter creator
 * @export
 */
export const AuthorizeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authorizeHeartbeatGet: async (body?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Authorize/Heartbeat`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (body !== undefined) {
                localVarQueryParameter['body'] = body;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AuthorizeLoginParams} [authorizeLoginParams] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authorizeLoginPost: async (authorizeLoginParams?: AuthorizeLoginParams, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Authorize/Login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(authorizeLoginParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthorizeApi - functional programming interface
 * @export
 */
export const AuthorizeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthorizeApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authorizeHeartbeatGet(body?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authorizeHeartbeatGet(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {AuthorizeLoginParams} [authorizeLoginParams] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authorizeLoginPost(authorizeLoginParams?: AuthorizeLoginParams, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Token>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authorizeLoginPost(authorizeLoginParams, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AuthorizeApi - factory interface
 * @export
 */
export const AuthorizeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthorizeApiFp(configuration)
    return {
        /**
         * 
         * @param {AuthorizeApiAuthorizeHeartbeatGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authorizeHeartbeatGet(requestParameters: AuthorizeApiAuthorizeHeartbeatGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<User> {
            return localVarFp.authorizeHeartbeatGet(requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AuthorizeApiAuthorizeLoginPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authorizeLoginPost(requestParameters: AuthorizeApiAuthorizeLoginPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Token> {
            return localVarFp.authorizeLoginPost(requestParameters.authorizeLoginParams, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for authorizeHeartbeatGet operation in AuthorizeApi.
 * @export
 * @interface AuthorizeApiAuthorizeHeartbeatGetRequest
 */
export interface AuthorizeApiAuthorizeHeartbeatGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AuthorizeApiAuthorizeHeartbeatGet
     */
    readonly body?: string
}

/**
 * Request parameters for authorizeLoginPost operation in AuthorizeApi.
 * @export
 * @interface AuthorizeApiAuthorizeLoginPostRequest
 */
export interface AuthorizeApiAuthorizeLoginPostRequest {
    /**
     * 
     * @type {AuthorizeLoginParams}
     * @memberof AuthorizeApiAuthorizeLoginPost
     */
    readonly authorizeLoginParams?: AuthorizeLoginParams
}

/**
 * AuthorizeApi - object-oriented interface
 * @export
 * @class AuthorizeApi
 * @extends {BaseAPI}
 */
export class AuthorizeApi extends BaseAPI {
    /**
     * 
     * @param {AuthorizeApiAuthorizeHeartbeatGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthorizeApi
     */
    public authorizeHeartbeatGet(requestParameters: AuthorizeApiAuthorizeHeartbeatGetRequest = {}, options?: AxiosRequestConfig) {
        return AuthorizeApiFp(this.configuration).authorizeHeartbeatGet(requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuthorizeApiAuthorizeLoginPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthorizeApi
     */




    public authorizeLoginPost(requestParameters: AuthorizeApiAuthorizeLoginPostRequest = {}, options?: AxiosRequestConfig) {
        return AuthorizeApiFp(this.configuration).authorizeLoginPost(requestParameters.authorizeLoginParams, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SubmissionApi - axios parameter creator
 * @export
 */
export const SubmissionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {FindParams} [findParams] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionAbandonJudgerPost: async (findParams?: FindParams, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Submission/AbandonJudger`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(findParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {FindParams} [findParams] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionAbandonSupervisorPost: async (findParams?: FindParams, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Submission/AbandonSupervisor`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(findParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SubmissionAuditCheckerModel} [submissionAuditCheckerModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionAuditCheckerPost: async (submissionAuditCheckerModel?: SubmissionAuditCheckerModel, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Submission/AuditChecker`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(submissionAuditCheckerModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SubmissionAuditJudgerModel} [submissionAuditJudgerModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionAuditJudgerPost: async (submissionAuditJudgerModel?: SubmissionAuditJudgerModel, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Submission/AuditJudger`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(submissionAuditJudgerModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SubmissionAuditSupervisorModel} [submissionAuditSupervisorModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionAuditSupervisorPost: async (submissionAuditSupervisorModel?: SubmissionAuditSupervisorModel, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Submission/AuditSupervisor`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(submissionAuditSupervisorModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateSubmissionModel} [createSubmissionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionCreatePost: async (createSubmissionModel?: CreateSubmissionModel, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Submission/Create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSubmissionModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SubmissionDeletePaperModel} [submissionDeletePaperModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionDeletePaperPost: async (submissionDeletePaperModel?: SubmissionDeletePaperModel, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Submission/DeletePaper`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(submissionDeletePaperModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SubmissionDistributeCheckerModel} [submissionDistributeCheckerModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionDistributeCheckerPost: async (submissionDistributeCheckerModel?: SubmissionDistributeCheckerModel, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Submission/DistributeChecker`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(submissionDistributeCheckerModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SubmissionDistributeJudgerModel} [submissionDistributeJudgerModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionDistributeJudgerPost: async (submissionDistributeJudgerModel?: SubmissionDistributeJudgerModel, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Submission/DistributeJudger`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(submissionDistributeJudgerModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SubmissionDistributeSupervisorModel} [submissionDistributeSupervisorModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionDistributeSupervisorPost: async (submissionDistributeSupervisorModel?: SubmissionDistributeSupervisorModel, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Submission/DistributeSupervisor`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(submissionDistributeSupervisorModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionFindGet: async (id?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Submission/Find`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['Id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<SubmissionStatus>} [inStatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionListGet: async (inStatus?: Array<SubmissionStatus>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Submission/List`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (inStatus) {
                localVarQueryParameter['InStatus'] = inStatus;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {FindParams} [findParams] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionRemovePost: async (findParams?: FindParams, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Submission/Remove`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(findParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {FindParams} [findParams] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionRevokePost: async (findParams?: FindParams, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Submission/Revoke`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(findParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {FindParams} [findParams] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionSendMessagePost: async (findParams?: FindParams, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Submission/SendMessage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(findParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {FindParams} [findParams] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionSubmitPost: async (findParams?: FindParams, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Submission/Submit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(findParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TeacherAuditModel} [teacherAuditModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionTeacherAuditPost: async (teacherAuditModel?: TeacherAuditModel, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Submission/TeacherAudit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(teacherAuditModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateSubmissionTermModel} [updateSubmissionTermModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionUpdateTermPost: async (updateSubmissionTermModel?: UpdateSubmissionTermModel, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Submission/UpdateTerm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSubmissionTermModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} isJudgeVersion 
         * @param {number} [id] 
         * @param {string} [contentType] 
         * @param {string} [contentDisposition] 
         * @param {number} [length] 
         * @param {string} [name] 
         * @param {string} [fileName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionUploadPaperPost: async (isJudgeVersion: boolean, id?: number, contentType?: string, contentDisposition?: string, length?: number, name?: string, fileName?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'isJudgeVersion' is not null or undefined
            assertParamExists('submissionUploadPaperPost', 'isJudgeVersion', isJudgeVersion)
            const localVarPath = `/Submission/UploadPaper`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (isJudgeVersion !== undefined) { 
                localVarFormParams.append('IsJudgeVersion', isJudgeVersion as any);
            }
    
            if (id !== undefined) { 
                localVarFormParams.append('Id', id as any);
            }
    
            if (contentType !== undefined) { 
                localVarFormParams.append('ContentType', contentType as any);
            }
    
            if (contentDisposition !== undefined) { 
                localVarFormParams.append('ContentDisposition', contentDisposition as any);
            }
    
            if (length !== undefined) { 
                localVarFormParams.append('Length', length as any);
            }
    
            if (name !== undefined) { 
                localVarFormParams.append('Name', name as any);
            }
    
            if (fileName !== undefined) { 
                localVarFormParams.append('FileName', fileName as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SubmissionApi - functional programming interface
 * @export
 */
export const SubmissionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SubmissionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {FindParams} [findParams] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submissionAbandonJudgerPost(findParams?: FindParams, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubmissionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submissionAbandonJudgerPost(findParams, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {FindParams} [findParams] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submissionAbandonSupervisorPost(findParams?: FindParams, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubmissionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submissionAbandonSupervisorPost(findParams, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SubmissionAuditCheckerModel} [submissionAuditCheckerModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submissionAuditCheckerPost(submissionAuditCheckerModel?: SubmissionAuditCheckerModel, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubmissionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submissionAuditCheckerPost(submissionAuditCheckerModel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SubmissionAuditJudgerModel} [submissionAuditJudgerModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submissionAuditJudgerPost(submissionAuditJudgerModel?: SubmissionAuditJudgerModel, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubmissionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submissionAuditJudgerPost(submissionAuditJudgerModel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SubmissionAuditSupervisorModel} [submissionAuditSupervisorModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submissionAuditSupervisorPost(submissionAuditSupervisorModel?: SubmissionAuditSupervisorModel, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubmissionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submissionAuditSupervisorPost(submissionAuditSupervisorModel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateSubmissionModel} [createSubmissionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submissionCreatePost(createSubmissionModel?: CreateSubmissionModel, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubmissionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submissionCreatePost(createSubmissionModel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SubmissionDeletePaperModel} [submissionDeletePaperModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submissionDeletePaperPost(submissionDeletePaperModel?: SubmissionDeletePaperModel, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubmissionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submissionDeletePaperPost(submissionDeletePaperModel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SubmissionDistributeCheckerModel} [submissionDistributeCheckerModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submissionDistributeCheckerPost(submissionDistributeCheckerModel?: SubmissionDistributeCheckerModel, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubmissionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submissionDistributeCheckerPost(submissionDistributeCheckerModel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SubmissionDistributeJudgerModel} [submissionDistributeJudgerModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submissionDistributeJudgerPost(submissionDistributeJudgerModel?: SubmissionDistributeJudgerModel, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubmissionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submissionDistributeJudgerPost(submissionDistributeJudgerModel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SubmissionDistributeSupervisorModel} [submissionDistributeSupervisorModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submissionDistributeSupervisorPost(submissionDistributeSupervisorModel?: SubmissionDistributeSupervisorModel, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubmissionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submissionDistributeSupervisorPost(submissionDistributeSupervisorModel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submissionFindGet(id?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubmissionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submissionFindGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<SubmissionStatus>} [inStatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submissionListGet(inStatus?: Array<SubmissionStatus>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SubmissionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submissionListGet(inStatus, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {FindParams} [findParams] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submissionRemovePost(findParams?: FindParams, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubmissionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submissionRemovePost(findParams, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {FindParams} [findParams] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submissionRevokePost(findParams?: FindParams, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubmissionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submissionRevokePost(findParams, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {FindParams} [findParams] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submissionSendMessagePost(findParams?: FindParams, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submissionSendMessagePost(findParams, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {FindParams} [findParams] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submissionSubmitPost(findParams?: FindParams, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubmissionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submissionSubmitPost(findParams, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {TeacherAuditModel} [teacherAuditModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submissionTeacherAuditPost(teacherAuditModel?: TeacherAuditModel, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubmissionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submissionTeacherAuditPost(teacherAuditModel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdateSubmissionTermModel} [updateSubmissionTermModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submissionUpdateTermPost(updateSubmissionTermModel?: UpdateSubmissionTermModel, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubmissionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submissionUpdateTermPost(updateSubmissionTermModel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {boolean} isJudgeVersion 
         * @param {number} [id] 
         * @param {string} [contentType] 
         * @param {string} [contentDisposition] 
         * @param {number} [length] 
         * @param {string} [name] 
         * @param {string} [fileName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submissionUploadPaperPost(isJudgeVersion: boolean, id?: number, contentType?: string, contentDisposition?: string, length?: number, name?: string, fileName?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubmissionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submissionUploadPaperPost(isJudgeVersion, id, contentType, contentDisposition, length, name, fileName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SubmissionApi - factory interface
 * @export
 */
export const SubmissionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SubmissionApiFp(configuration)
    return {
        /**
         * 
         * @param {SubmissionApiSubmissionAbandonJudgerPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionAbandonJudgerPost(requestParameters: SubmissionApiSubmissionAbandonJudgerPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<SubmissionDto> {
            return localVarFp.submissionAbandonJudgerPost(requestParameters.findParams, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SubmissionApiSubmissionAbandonSupervisorPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionAbandonSupervisorPost(requestParameters: SubmissionApiSubmissionAbandonSupervisorPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<SubmissionDto> {
            return localVarFp.submissionAbandonSupervisorPost(requestParameters.findParams, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SubmissionApiSubmissionAuditCheckerPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionAuditCheckerPost(requestParameters: SubmissionApiSubmissionAuditCheckerPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<SubmissionDto> {
            return localVarFp.submissionAuditCheckerPost(requestParameters.submissionAuditCheckerModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SubmissionApiSubmissionAuditJudgerPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionAuditJudgerPost(requestParameters: SubmissionApiSubmissionAuditJudgerPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<SubmissionDto> {
            return localVarFp.submissionAuditJudgerPost(requestParameters.submissionAuditJudgerModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SubmissionApiSubmissionAuditSupervisorPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionAuditSupervisorPost(requestParameters: SubmissionApiSubmissionAuditSupervisorPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<SubmissionDto> {
            return localVarFp.submissionAuditSupervisorPost(requestParameters.submissionAuditSupervisorModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SubmissionApiSubmissionCreatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionCreatePost(requestParameters: SubmissionApiSubmissionCreatePostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<SubmissionDto> {
            return localVarFp.submissionCreatePost(requestParameters.createSubmissionModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SubmissionApiSubmissionDeletePaperPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionDeletePaperPost(requestParameters: SubmissionApiSubmissionDeletePaperPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<SubmissionDto> {
            return localVarFp.submissionDeletePaperPost(requestParameters.submissionDeletePaperModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SubmissionApiSubmissionDistributeCheckerPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionDistributeCheckerPost(requestParameters: SubmissionApiSubmissionDistributeCheckerPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<SubmissionDto> {
            return localVarFp.submissionDistributeCheckerPost(requestParameters.submissionDistributeCheckerModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SubmissionApiSubmissionDistributeJudgerPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionDistributeJudgerPost(requestParameters: SubmissionApiSubmissionDistributeJudgerPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<SubmissionDto> {
            return localVarFp.submissionDistributeJudgerPost(requestParameters.submissionDistributeJudgerModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SubmissionApiSubmissionDistributeSupervisorPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionDistributeSupervisorPost(requestParameters: SubmissionApiSubmissionDistributeSupervisorPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<SubmissionDto> {
            return localVarFp.submissionDistributeSupervisorPost(requestParameters.submissionDistributeSupervisorModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SubmissionApiSubmissionFindGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionFindGet(requestParameters: SubmissionApiSubmissionFindGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<SubmissionDto> {
            return localVarFp.submissionFindGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SubmissionApiSubmissionListGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionListGet(requestParameters: SubmissionApiSubmissionListGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Array<SubmissionDto>> {
            return localVarFp.submissionListGet(requestParameters.inStatus, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SubmissionApiSubmissionRemovePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionRemovePost(requestParameters: SubmissionApiSubmissionRemovePostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<SubmissionDto> {
            return localVarFp.submissionRemovePost(requestParameters.findParams, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SubmissionApiSubmissionRevokePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionRevokePost(requestParameters: SubmissionApiSubmissionRevokePostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<SubmissionDto> {
            return localVarFp.submissionRevokePost(requestParameters.findParams, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SubmissionApiSubmissionSendMessagePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionSendMessagePost(requestParameters: SubmissionApiSubmissionSendMessagePostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.submissionSendMessagePost(requestParameters.findParams, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SubmissionApiSubmissionSubmitPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionSubmitPost(requestParameters: SubmissionApiSubmissionSubmitPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<SubmissionDto> {
            return localVarFp.submissionSubmitPost(requestParameters.findParams, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SubmissionApiSubmissionTeacherAuditPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionTeacherAuditPost(requestParameters: SubmissionApiSubmissionTeacherAuditPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<SubmissionDto> {
            return localVarFp.submissionTeacherAuditPost(requestParameters.teacherAuditModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SubmissionApiSubmissionUpdateTermPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionUpdateTermPost(requestParameters: SubmissionApiSubmissionUpdateTermPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<SubmissionDto> {
            return localVarFp.submissionUpdateTermPost(requestParameters.updateSubmissionTermModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SubmissionApiSubmissionUploadPaperPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionUploadPaperPost(requestParameters: SubmissionApiSubmissionUploadPaperPostRequest, options?: AxiosRequestConfig): AxiosPromise<SubmissionDto> {
            return localVarFp.submissionUploadPaperPost(requestParameters.isJudgeVersion, requestParameters.id, requestParameters.contentType, requestParameters.contentDisposition, requestParameters.length, requestParameters.name, requestParameters.fileName, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for submissionAbandonJudgerPost operation in SubmissionApi.
 * @export
 * @interface SubmissionApiSubmissionAbandonJudgerPostRequest
 */
export interface SubmissionApiSubmissionAbandonJudgerPostRequest {
    /**
     * 
     * @type {FindParams}
     * @memberof SubmissionApiSubmissionAbandonJudgerPost
     */
    readonly findParams?: FindParams
}

/**
 * Request parameters for submissionAbandonSupervisorPost operation in SubmissionApi.
 * @export
 * @interface SubmissionApiSubmissionAbandonSupervisorPostRequest
 */
export interface SubmissionApiSubmissionAbandonSupervisorPostRequest {
    /**
     * 
     * @type {FindParams}
     * @memberof SubmissionApiSubmissionAbandonSupervisorPost
     */
    readonly findParams?: FindParams
}

/**
 * Request parameters for submissionAuditCheckerPost operation in SubmissionApi.
 * @export
 * @interface SubmissionApiSubmissionAuditCheckerPostRequest
 */
export interface SubmissionApiSubmissionAuditCheckerPostRequest {
    /**
     * 
     * @type {SubmissionAuditCheckerModel}
     * @memberof SubmissionApiSubmissionAuditCheckerPost
     */
    readonly submissionAuditCheckerModel?: SubmissionAuditCheckerModel
}

/**
 * Request parameters for submissionAuditJudgerPost operation in SubmissionApi.
 * @export
 * @interface SubmissionApiSubmissionAuditJudgerPostRequest
 */
export interface SubmissionApiSubmissionAuditJudgerPostRequest {
    /**
     * 
     * @type {SubmissionAuditJudgerModel}
     * @memberof SubmissionApiSubmissionAuditJudgerPost
     */
    readonly submissionAuditJudgerModel?: SubmissionAuditJudgerModel
}

/**
 * Request parameters for submissionAuditSupervisorPost operation in SubmissionApi.
 * @export
 * @interface SubmissionApiSubmissionAuditSupervisorPostRequest
 */
export interface SubmissionApiSubmissionAuditSupervisorPostRequest {
    /**
     * 
     * @type {SubmissionAuditSupervisorModel}
     * @memberof SubmissionApiSubmissionAuditSupervisorPost
     */
    readonly submissionAuditSupervisorModel?: SubmissionAuditSupervisorModel
}

/**
 * Request parameters for submissionCreatePost operation in SubmissionApi.
 * @export
 * @interface SubmissionApiSubmissionCreatePostRequest
 */
export interface SubmissionApiSubmissionCreatePostRequest {
    /**
     * 
     * @type {CreateSubmissionModel}
     * @memberof SubmissionApiSubmissionCreatePost
     */
    readonly createSubmissionModel?: CreateSubmissionModel
}

/**
 * Request parameters for submissionDeletePaperPost operation in SubmissionApi.
 * @export
 * @interface SubmissionApiSubmissionDeletePaperPostRequest
 */
export interface SubmissionApiSubmissionDeletePaperPostRequest {
    /**
     * 
     * @type {SubmissionDeletePaperModel}
     * @memberof SubmissionApiSubmissionDeletePaperPost
     */
    readonly submissionDeletePaperModel?: SubmissionDeletePaperModel
}

/**
 * Request parameters for submissionDistributeCheckerPost operation in SubmissionApi.
 * @export
 * @interface SubmissionApiSubmissionDistributeCheckerPostRequest
 */
export interface SubmissionApiSubmissionDistributeCheckerPostRequest {
    /**
     * 
     * @type {SubmissionDistributeCheckerModel}
     * @memberof SubmissionApiSubmissionDistributeCheckerPost
     */
    readonly submissionDistributeCheckerModel?: SubmissionDistributeCheckerModel
}

/**
 * Request parameters for submissionDistributeJudgerPost operation in SubmissionApi.
 * @export
 * @interface SubmissionApiSubmissionDistributeJudgerPostRequest
 */
export interface SubmissionApiSubmissionDistributeJudgerPostRequest {
    /**
     * 
     * @type {SubmissionDistributeJudgerModel}
     * @memberof SubmissionApiSubmissionDistributeJudgerPost
     */
    readonly submissionDistributeJudgerModel?: SubmissionDistributeJudgerModel
}

/**
 * Request parameters for submissionDistributeSupervisorPost operation in SubmissionApi.
 * @export
 * @interface SubmissionApiSubmissionDistributeSupervisorPostRequest
 */
export interface SubmissionApiSubmissionDistributeSupervisorPostRequest {
    /**
     * 
     * @type {SubmissionDistributeSupervisorModel}
     * @memberof SubmissionApiSubmissionDistributeSupervisorPost
     */
    readonly submissionDistributeSupervisorModel?: SubmissionDistributeSupervisorModel
}

/**
 * Request parameters for submissionFindGet operation in SubmissionApi.
 * @export
 * @interface SubmissionApiSubmissionFindGetRequest
 */
export interface SubmissionApiSubmissionFindGetRequest {
    /**
     * 
     * @type {number}
     * @memberof SubmissionApiSubmissionFindGet
     */
    readonly id?: number
}

/**
 * Request parameters for submissionListGet operation in SubmissionApi.
 * @export
 * @interface SubmissionApiSubmissionListGetRequest
 */
export interface SubmissionApiSubmissionListGetRequest {
    /**
     * 
     * @type {Array<SubmissionStatus>}
     * @memberof SubmissionApiSubmissionListGet
     */
    readonly inStatus?: Array<SubmissionStatus>
}

/**
 * Request parameters for submissionRemovePost operation in SubmissionApi.
 * @export
 * @interface SubmissionApiSubmissionRemovePostRequest
 */
export interface SubmissionApiSubmissionRemovePostRequest {
    /**
     * 
     * @type {FindParams}
     * @memberof SubmissionApiSubmissionRemovePost
     */
    readonly findParams?: FindParams
}

/**
 * Request parameters for submissionRevokePost operation in SubmissionApi.
 * @export
 * @interface SubmissionApiSubmissionRevokePostRequest
 */
export interface SubmissionApiSubmissionRevokePostRequest {
    /**
     * 
     * @type {FindParams}
     * @memberof SubmissionApiSubmissionRevokePost
     */
    readonly findParams?: FindParams
}

/**
 * Request parameters for submissionSendMessagePost operation in SubmissionApi.
 * @export
 * @interface SubmissionApiSubmissionSendMessagePostRequest
 */
export interface SubmissionApiSubmissionSendMessagePostRequest {
    /**
     * 
     * @type {FindParams}
     * @memberof SubmissionApiSubmissionSendMessagePost
     */
    readonly findParams?: FindParams
}

/**
 * Request parameters for submissionSubmitPost operation in SubmissionApi.
 * @export
 * @interface SubmissionApiSubmissionSubmitPostRequest
 */
export interface SubmissionApiSubmissionSubmitPostRequest {
    /**
     * 
     * @type {FindParams}
     * @memberof SubmissionApiSubmissionSubmitPost
     */
    readonly findParams?: FindParams
}

/**
 * Request parameters for submissionTeacherAuditPost operation in SubmissionApi.
 * @export
 * @interface SubmissionApiSubmissionTeacherAuditPostRequest
 */
export interface SubmissionApiSubmissionTeacherAuditPostRequest {
    /**
     * 
     * @type {TeacherAuditModel}
     * @memberof SubmissionApiSubmissionTeacherAuditPost
     */
    readonly teacherAuditModel?: TeacherAuditModel
}

/**
 * Request parameters for submissionUpdateTermPost operation in SubmissionApi.
 * @export
 * @interface SubmissionApiSubmissionUpdateTermPostRequest
 */
export interface SubmissionApiSubmissionUpdateTermPostRequest {
    /**
     * 
     * @type {UpdateSubmissionTermModel}
     * @memberof SubmissionApiSubmissionUpdateTermPost
     */
    readonly updateSubmissionTermModel?: UpdateSubmissionTermModel
}

/**
 * Request parameters for submissionUploadPaperPost operation in SubmissionApi.
 * @export
 * @interface SubmissionApiSubmissionUploadPaperPostRequest
 */
export interface SubmissionApiSubmissionUploadPaperPostRequest {
    /**
     * 
     * @type {boolean}
     * @memberof SubmissionApiSubmissionUploadPaperPost
     */
    readonly isJudgeVersion: boolean

    /**
     * 
     * @type {number}
     * @memberof SubmissionApiSubmissionUploadPaperPost
     */
    readonly id?: number

    /**
     * 
     * @type {string}
     * @memberof SubmissionApiSubmissionUploadPaperPost
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof SubmissionApiSubmissionUploadPaperPost
     */
    readonly contentDisposition?: string

    /**
     * 
     * @type {number}
     * @memberof SubmissionApiSubmissionUploadPaperPost
     */
    readonly length?: number

    /**
     * 
     * @type {string}
     * @memberof SubmissionApiSubmissionUploadPaperPost
     */
    readonly name?: string

    /**
     * 
     * @type {string}
     * @memberof SubmissionApiSubmissionUploadPaperPost
     */
    readonly fileName?: string
}

/**
 * SubmissionApi - object-oriented interface
 * @export
 * @class SubmissionApi
 * @extends {BaseAPI}
 */
export class SubmissionApi extends BaseAPI {
    /**
     * 
     * @param {SubmissionApiSubmissionAbandonJudgerPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubmissionApi
     */
    public submissionAbandonJudgerPost(requestParameters: SubmissionApiSubmissionAbandonJudgerPostRequest = {}, options?: AxiosRequestConfig) {
        return SubmissionApiFp(this.configuration).submissionAbandonJudgerPost(requestParameters.findParams, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SubmissionApiSubmissionAbandonSupervisorPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubmissionApi
     */
    public submissionAbandonSupervisorPost(requestParameters: SubmissionApiSubmissionAbandonSupervisorPostRequest = {}, options?: AxiosRequestConfig) {
        return SubmissionApiFp(this.configuration).submissionAbandonSupervisorPost(requestParameters.findParams, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SubmissionApiSubmissionAuditCheckerPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubmissionApi
     */
    public submissionAuditCheckerPost(requestParameters: SubmissionApiSubmissionAuditCheckerPostRequest = {}, options?: AxiosRequestConfig) {
        return SubmissionApiFp(this.configuration).submissionAuditCheckerPost(requestParameters.submissionAuditCheckerModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SubmissionApiSubmissionAuditJudgerPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubmissionApi
     */
    public submissionAuditJudgerPost(requestParameters: SubmissionApiSubmissionAuditJudgerPostRequest = {}, options?: AxiosRequestConfig) {
        return SubmissionApiFp(this.configuration).submissionAuditJudgerPost(requestParameters.submissionAuditJudgerModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SubmissionApiSubmissionAuditSupervisorPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubmissionApi
     */
    public submissionAuditSupervisorPost(requestParameters: SubmissionApiSubmissionAuditSupervisorPostRequest = {}, options?: AxiosRequestConfig) {
        return SubmissionApiFp(this.configuration).submissionAuditSupervisorPost(requestParameters.submissionAuditSupervisorModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SubmissionApiSubmissionCreatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubmissionApi
     */
    public submissionCreatePost(requestParameters: SubmissionApiSubmissionCreatePostRequest = {}, options?: AxiosRequestConfig) {
        return SubmissionApiFp(this.configuration).submissionCreatePost(requestParameters.createSubmissionModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SubmissionApiSubmissionDeletePaperPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubmissionApi
     */
    public submissionDeletePaperPost(requestParameters: SubmissionApiSubmissionDeletePaperPostRequest = {}, options?: AxiosRequestConfig) {
        return SubmissionApiFp(this.configuration).submissionDeletePaperPost(requestParameters.submissionDeletePaperModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SubmissionApiSubmissionDistributeCheckerPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubmissionApi
     */
    public submissionDistributeCheckerPost(requestParameters: SubmissionApiSubmissionDistributeCheckerPostRequest = {}, options?: AxiosRequestConfig) {
        return SubmissionApiFp(this.configuration).submissionDistributeCheckerPost(requestParameters.submissionDistributeCheckerModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SubmissionApiSubmissionDistributeJudgerPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubmissionApi
     */
    public submissionDistributeJudgerPost(requestParameters: SubmissionApiSubmissionDistributeJudgerPostRequest = {}, options?: AxiosRequestConfig) {
        return SubmissionApiFp(this.configuration).submissionDistributeJudgerPost(requestParameters.submissionDistributeJudgerModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SubmissionApiSubmissionDistributeSupervisorPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubmissionApi
     */
    public submissionDistributeSupervisorPost(requestParameters: SubmissionApiSubmissionDistributeSupervisorPostRequest = {}, options?: AxiosRequestConfig) {
        return SubmissionApiFp(this.configuration).submissionDistributeSupervisorPost(requestParameters.submissionDistributeSupervisorModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SubmissionApiSubmissionFindGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubmissionApi
     */
    public submissionFindGet(requestParameters: SubmissionApiSubmissionFindGetRequest = {}, options?: AxiosRequestConfig) {
        return SubmissionApiFp(this.configuration).submissionFindGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SubmissionApiSubmissionListGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubmissionApi
     */
    public submissionListGet(requestParameters: SubmissionApiSubmissionListGetRequest = {}, options?: AxiosRequestConfig) {
        return SubmissionApiFp(this.configuration).submissionListGet(requestParameters.inStatus, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SubmissionApiSubmissionRemovePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubmissionApi
     */
    public submissionRemovePost(requestParameters: SubmissionApiSubmissionRemovePostRequest = {}, options?: AxiosRequestConfig) {
        return SubmissionApiFp(this.configuration).submissionRemovePost(requestParameters.findParams, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SubmissionApiSubmissionRevokePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubmissionApi
     */
    public submissionRevokePost(requestParameters: SubmissionApiSubmissionRevokePostRequest = {}, options?: AxiosRequestConfig) {
        return SubmissionApiFp(this.configuration).submissionRevokePost(requestParameters.findParams, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SubmissionApiSubmissionSendMessagePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubmissionApi
     */
    public submissionSendMessagePost(requestParameters: SubmissionApiSubmissionSendMessagePostRequest = {}, options?: AxiosRequestConfig) {
        return SubmissionApiFp(this.configuration).submissionSendMessagePost(requestParameters.findParams, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SubmissionApiSubmissionSubmitPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubmissionApi
     */
    public submissionSubmitPost(requestParameters: SubmissionApiSubmissionSubmitPostRequest = {}, options?: AxiosRequestConfig) {
        return SubmissionApiFp(this.configuration).submissionSubmitPost(requestParameters.findParams, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SubmissionApiSubmissionTeacherAuditPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubmissionApi
     */
    public submissionTeacherAuditPost(requestParameters: SubmissionApiSubmissionTeacherAuditPostRequest = {}, options?: AxiosRequestConfig) {
        return SubmissionApiFp(this.configuration).submissionTeacherAuditPost(requestParameters.teacherAuditModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SubmissionApiSubmissionUpdateTermPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubmissionApi
     */
    public submissionUpdateTermPost(requestParameters: SubmissionApiSubmissionUpdateTermPostRequest = {}, options?: AxiosRequestConfig) {
        return SubmissionApiFp(this.configuration).submissionUpdateTermPost(requestParameters.updateSubmissionTermModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SubmissionApiSubmissionUploadPaperPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubmissionApi
     */
    public submissionUploadPaperPost(requestParameters: SubmissionApiSubmissionUploadPaperPostRequest, options?: AxiosRequestConfig) {
        return SubmissionApiFp(this.configuration).submissionUploadPaperPost(requestParameters.isJudgeVersion, requestParameters.id, requestParameters.contentType, requestParameters.contentDisposition, requestParameters.length, requestParameters.name, requestParameters.fileName, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TermApi - axios parameter creator
 * @export
 */
export const TermApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        termExportJudgeGet: async (id?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Term/ExportJudge`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['Id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        termExportStudentGet: async (id?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Term/ExportStudent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['Id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        termExportSupervisorGet: async (id?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Term/ExportSupervisor`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['Id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        termListGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Term/List`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SaveTermModel} [saveTermModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        termSavePost: async (saveTermModel?: SaveTermModel, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Term/Save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveTermModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TermApi - functional programming interface
 * @export
 */
export const TermApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TermApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async termExportJudgeGet(id?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExcelExportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.termExportJudgeGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async termExportStudentGet(id?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExcelExportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.termExportStudentGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async termExportSupervisorGet(id?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExcelExportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.termExportSupervisorGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async termListGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Term>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.termListGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SaveTermModel} [saveTermModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async termSavePost(saveTermModel?: SaveTermModel, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Term>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.termSavePost(saveTermModel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TermApi - factory interface
 * @export
 */
export const TermApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TermApiFp(configuration)
    return {
        /**
         * 
         * @param {TermApiTermExportJudgeGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        termExportJudgeGet(requestParameters: TermApiTermExportJudgeGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<ExcelExportResponse> {
            return localVarFp.termExportJudgeGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TermApiTermExportStudentGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        termExportStudentGet(requestParameters: TermApiTermExportStudentGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<ExcelExportResponse> {
            return localVarFp.termExportStudentGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TermApiTermExportSupervisorGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        termExportSupervisorGet(requestParameters: TermApiTermExportSupervisorGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<ExcelExportResponse> {
            return localVarFp.termExportSupervisorGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        termListGet(options?: AxiosRequestConfig): AxiosPromise<Array<Term>> {
            return localVarFp.termListGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TermApiTermSavePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        termSavePost(requestParameters: TermApiTermSavePostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Term> {
            return localVarFp.termSavePost(requestParameters.saveTermModel, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for termExportJudgeGet operation in TermApi.
 * @export
 * @interface TermApiTermExportJudgeGetRequest
 */
export interface TermApiTermExportJudgeGetRequest {
    /**
     * 
     * @type {number}
     * @memberof TermApiTermExportJudgeGet
     */
    readonly id?: number
}

/**
 * Request parameters for termExportStudentGet operation in TermApi.
 * @export
 * @interface TermApiTermExportStudentGetRequest
 */
export interface TermApiTermExportStudentGetRequest {
    /**
     * 
     * @type {number}
     * @memberof TermApiTermExportStudentGet
     */
    readonly id?: number
}

/**
 * Request parameters for termExportSupervisorGet operation in TermApi.
 * @export
 * @interface TermApiTermExportSupervisorGetRequest
 */
export interface TermApiTermExportSupervisorGetRequest {
    /**
     * 
     * @type {number}
     * @memberof TermApiTermExportSupervisorGet
     */
    readonly id?: number
}

/**
 * Request parameters for termSavePost operation in TermApi.
 * @export
 * @interface TermApiTermSavePostRequest
 */
export interface TermApiTermSavePostRequest {
    /**
     * 
     * @type {SaveTermModel}
     * @memberof TermApiTermSavePost
     */
    readonly saveTermModel?: SaveTermModel
}

/**
 * TermApi - object-oriented interface
 * @export
 * @class TermApi
 * @extends {BaseAPI}
 */
export class TermApi extends BaseAPI {
    /**
     * 
     * @param {TermApiTermExportJudgeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TermApi
     */
    public termExportJudgeGet(requestParameters: TermApiTermExportJudgeGetRequest = {}, options?: AxiosRequestConfig) {
        return TermApiFp(this.configuration).termExportJudgeGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TermApiTermExportStudentGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TermApi
     */
    public termExportStudentGet(requestParameters: TermApiTermExportStudentGetRequest = {}, options?: AxiosRequestConfig) {
        return TermApiFp(this.configuration).termExportStudentGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TermApiTermExportSupervisorGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TermApi
     */
    public termExportSupervisorGet(requestParameters: TermApiTermExportSupervisorGetRequest = {}, options?: AxiosRequestConfig) {
        return TermApiFp(this.configuration).termExportSupervisorGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TermApi
     */
    public termListGet(options?: AxiosRequestConfig) {
        return TermApiFp(this.configuration).termListGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TermApiTermSavePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TermApi
     */
    public termSavePost(requestParameters: TermApiTermSavePostRequest = {}, options?: AxiosRequestConfig) {
        return TermApiFp(this.configuration).termSavePost(requestParameters.saveTermModel, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UserApi - axios parameter creator
 * @export
 */
export const UserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {UserFindParams} [userFindParams] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userDeletePost: async (userFindParams?: UserFindParams, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/User/Delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userFindParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userFindGet: async (id?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/User/Find`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['Id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UserGetDefaultPasswordParams} [userGetDefaultPasswordParams] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGetDefaultPasswordPost: async (userGetDefaultPasswordParams?: UserGetDefaultPasswordParams, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/User/GetDefaultPassword`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userGetDefaultPasswordParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGetStudentExcelTemplateGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/User/GetStudentExcelTemplate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGetStudentStatusExcelTemplateGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/User/GetStudentStatusExcelTemplate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGetTeacherExcelTemplateGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/User/GetTeacherExcelTemplate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [contentType] 
         * @param {string} [contentDisposition] 
         * @param {number} [length] 
         * @param {string} [name] 
         * @param {string} [fileName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userImportStudentPost: async (contentType?: string, contentDisposition?: string, length?: number, name?: string, fileName?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/User/ImportStudent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (contentType !== undefined) { 
                localVarFormParams.append('ContentType', contentType as any);
            }
    
            if (contentDisposition !== undefined) { 
                localVarFormParams.append('ContentDisposition', contentDisposition as any);
            }
    
            if (length !== undefined) { 
                localVarFormParams.append('Length', length as any);
            }
    
            if (name !== undefined) { 
                localVarFormParams.append('Name', name as any);
            }
    
            if (fileName !== undefined) { 
                localVarFormParams.append('FileName', fileName as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [contentType] 
         * @param {string} [contentDisposition] 
         * @param {number} [length] 
         * @param {string} [name] 
         * @param {string} [fileName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userImportStudentStatusPost: async (contentType?: string, contentDisposition?: string, length?: number, name?: string, fileName?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/User/ImportStudentStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (contentType !== undefined) { 
                localVarFormParams.append('ContentType', contentType as any);
            }
    
            if (contentDisposition !== undefined) { 
                localVarFormParams.append('ContentDisposition', contentDisposition as any);
            }
    
            if (length !== undefined) { 
                localVarFormParams.append('Length', length as any);
            }
    
            if (name !== undefined) { 
                localVarFormParams.append('Name', name as any);
            }
    
            if (fileName !== undefined) { 
                localVarFormParams.append('FileName', fileName as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} isSupervisor 
         * @param {boolean} isJudge 
         * @param {boolean} isChecker 
         * @param {string} [contentType] 
         * @param {string} [contentDisposition] 
         * @param {number} [length] 
         * @param {string} [name] 
         * @param {string} [fileName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userImportTeacherPost: async (isSupervisor: boolean, isJudge: boolean, isChecker: boolean, contentType?: string, contentDisposition?: string, length?: number, name?: string, fileName?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'isSupervisor' is not null or undefined
            assertParamExists('userImportTeacherPost', 'isSupervisor', isSupervisor)
            // verify required parameter 'isJudge' is not null or undefined
            assertParamExists('userImportTeacherPost', 'isJudge', isJudge)
            // verify required parameter 'isChecker' is not null or undefined
            assertParamExists('userImportTeacherPost', 'isChecker', isChecker)
            const localVarPath = `/User/ImportTeacher`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (contentType !== undefined) { 
                localVarFormParams.append('ContentType', contentType as any);
            }
    
            if (contentDisposition !== undefined) { 
                localVarFormParams.append('ContentDisposition', contentDisposition as any);
            }
    
            if (length !== undefined) { 
                localVarFormParams.append('Length', length as any);
            }
    
            if (name !== undefined) { 
                localVarFormParams.append('Name', name as any);
            }
    
            if (fileName !== undefined) { 
                localVarFormParams.append('FileName', fileName as any);
            }
    
            if (isSupervisor !== undefined) { 
                localVarFormParams.append('IsSupervisor', isSupervisor as any);
            }
    
            if (isJudge !== undefined) { 
                localVarFormParams.append('IsJudge', isJudge as any);
            }
    
            if (isChecker !== undefined) { 
                localVarFormParams.append('IsChecker', isChecker as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userListGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/User/List`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UserToggleTeacherTypeModel} [userToggleTeacherTypeModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userToggleTeacherTypePost: async (userToggleTeacherTypeModel?: UserToggleTeacherTypeModel, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/User/ToggleTeacherType`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userToggleTeacherTypeModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UserUpdatePasswordModel} [userUpdatePasswordModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUpdatePasswordPost: async (userUpdatePasswordModel?: UserUpdatePasswordModel, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/User/UpdatePassword`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userUpdatePasswordModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {StudentUpdateInfoModel} [studentUpdateInfoModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUpdateStudentInfoPost: async (studentUpdateInfoModel?: StudentUpdateInfoModel, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/User/UpdateStudentInfo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(studentUpdateInfoModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserApi - functional programming interface
 * @export
 */
export const UserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {UserFindParams} [userFindParams] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userDeletePost(userFindParams?: UserFindParams, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userDeletePost(userFindParams, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userFindGet(id?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userFindGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UserGetDefaultPasswordParams} [userGetDefaultPasswordParams] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userGetDefaultPasswordPost(userGetDefaultPasswordParams?: UserGetDefaultPasswordParams, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userGetDefaultPasswordPost(userGetDefaultPasswordParams, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userGetStudentExcelTemplateGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetExcelTemplateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userGetStudentExcelTemplateGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userGetStudentStatusExcelTemplateGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetExcelTemplateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userGetStudentStatusExcelTemplateGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userGetTeacherExcelTemplateGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetExcelTemplateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userGetTeacherExcelTemplateGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [contentType] 
         * @param {string} [contentDisposition] 
         * @param {number} [length] 
         * @param {string} [name] 
         * @param {string} [fileName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userImportStudentPost(contentType?: string, contentDisposition?: string, length?: number, name?: string, fileName?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userImportStudentPost(contentType, contentDisposition, length, name, fileName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [contentType] 
         * @param {string} [contentDisposition] 
         * @param {number} [length] 
         * @param {string} [name] 
         * @param {string} [fileName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userImportStudentStatusPost(contentType?: string, contentDisposition?: string, length?: number, name?: string, fileName?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExcelImportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userImportStudentStatusPost(contentType, contentDisposition, length, name, fileName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {boolean} isSupervisor 
         * @param {boolean} isJudge 
         * @param {boolean} isChecker 
         * @param {string} [contentType] 
         * @param {string} [contentDisposition] 
         * @param {number} [length] 
         * @param {string} [name] 
         * @param {string} [fileName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userImportTeacherPost(isSupervisor: boolean, isJudge: boolean, isChecker: boolean, contentType?: string, contentDisposition?: string, length?: number, name?: string, fileName?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExcelImportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userImportTeacherPost(isSupervisor, isJudge, isChecker, contentType, contentDisposition, length, name, fileName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userListGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userListGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UserToggleTeacherTypeModel} [userToggleTeacherTypeModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userToggleTeacherTypePost(userToggleTeacherTypeModel?: UserToggleTeacherTypeModel, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userToggleTeacherTypePost(userToggleTeacherTypeModel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UserUpdatePasswordModel} [userUpdatePasswordModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userUpdatePasswordPost(userUpdatePasswordModel?: UserUpdatePasswordModel, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userUpdatePasswordPost(userUpdatePasswordModel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {StudentUpdateInfoModel} [studentUpdateInfoModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userUpdateStudentInfoPost(studentUpdateInfoModel?: StudentUpdateInfoModel, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userUpdateStudentInfoPost(studentUpdateInfoModel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserApi - factory interface
 * @export
 */
export const UserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserApiFp(configuration)
    return {
        /**
         * 
         * @param {UserApiUserDeletePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userDeletePost(requestParameters: UserApiUserDeletePostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.userDeletePost(requestParameters.userFindParams, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiUserFindGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userFindGet(requestParameters: UserApiUserFindGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<UserDto> {
            return localVarFp.userFindGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiUserGetDefaultPasswordPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGetDefaultPasswordPost(requestParameters: UserApiUserGetDefaultPasswordPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.userGetDefaultPasswordPost(requestParameters.userGetDefaultPasswordParams, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGetStudentExcelTemplateGet(options?: AxiosRequestConfig): AxiosPromise<GetExcelTemplateResponse> {
            return localVarFp.userGetStudentExcelTemplateGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGetStudentStatusExcelTemplateGet(options?: AxiosRequestConfig): AxiosPromise<GetExcelTemplateResponse> {
            return localVarFp.userGetStudentStatusExcelTemplateGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGetTeacherExcelTemplateGet(options?: AxiosRequestConfig): AxiosPromise<GetExcelTemplateResponse> {
            return localVarFp.userGetTeacherExcelTemplateGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiUserImportStudentPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userImportStudentPost(requestParameters: UserApiUserImportStudentPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.userImportStudentPost(requestParameters.contentType, requestParameters.contentDisposition, requestParameters.length, requestParameters.name, requestParameters.fileName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiUserImportStudentStatusPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userImportStudentStatusPost(requestParameters: UserApiUserImportStudentStatusPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<ExcelImportResponse> {
            return localVarFp.userImportStudentStatusPost(requestParameters.contentType, requestParameters.contentDisposition, requestParameters.length, requestParameters.name, requestParameters.fileName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiUserImportTeacherPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userImportTeacherPost(requestParameters: UserApiUserImportTeacherPostRequest, options?: AxiosRequestConfig): AxiosPromise<ExcelImportResponse> {
            return localVarFp.userImportTeacherPost(requestParameters.isSupervisor, requestParameters.isJudge, requestParameters.isChecker, requestParameters.contentType, requestParameters.contentDisposition, requestParameters.length, requestParameters.name, requestParameters.fileName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userListGet(options?: AxiosRequestConfig): AxiosPromise<Array<UserDto>> {
            return localVarFp.userListGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiUserToggleTeacherTypePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userToggleTeacherTypePost(requestParameters: UserApiUserToggleTeacherTypePostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<UserDto> {
            return localVarFp.userToggleTeacherTypePost(requestParameters.userToggleTeacherTypeModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiUserUpdatePasswordPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUpdatePasswordPost(requestParameters: UserApiUserUpdatePasswordPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<UserDto> {
            return localVarFp.userUpdatePasswordPost(requestParameters.userUpdatePasswordModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiUserUpdateStudentInfoPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUpdateStudentInfoPost(requestParameters: UserApiUserUpdateStudentInfoPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<UserDto> {
            return localVarFp.userUpdateStudentInfoPost(requestParameters.studentUpdateInfoModel, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for userDeletePost operation in UserApi.
 * @export
 * @interface UserApiUserDeletePostRequest
 */
export interface UserApiUserDeletePostRequest {
    /**
     * 
     * @type {UserFindParams}
     * @memberof UserApiUserDeletePost
     */
    readonly userFindParams?: UserFindParams
}

/**
 * Request parameters for userFindGet operation in UserApi.
 * @export
 * @interface UserApiUserFindGetRequest
 */
export interface UserApiUserFindGetRequest {
    /**
     * 
     * @type {number}
     * @memberof UserApiUserFindGet
     */
    readonly id?: number
}

/**
 * Request parameters for userGetDefaultPasswordPost operation in UserApi.
 * @export
 * @interface UserApiUserGetDefaultPasswordPostRequest
 */
export interface UserApiUserGetDefaultPasswordPostRequest {
    /**
     * 
     * @type {UserGetDefaultPasswordParams}
     * @memberof UserApiUserGetDefaultPasswordPost
     */
    readonly userGetDefaultPasswordParams?: UserGetDefaultPasswordParams
}

/**
 * Request parameters for userImportStudentPost operation in UserApi.
 * @export
 * @interface UserApiUserImportStudentPostRequest
 */
export interface UserApiUserImportStudentPostRequest {
    /**
     * 
     * @type {string}
     * @memberof UserApiUserImportStudentPost
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof UserApiUserImportStudentPost
     */
    readonly contentDisposition?: string

    /**
     * 
     * @type {number}
     * @memberof UserApiUserImportStudentPost
     */
    readonly length?: number

    /**
     * 
     * @type {string}
     * @memberof UserApiUserImportStudentPost
     */
    readonly name?: string

    /**
     * 
     * @type {string}
     * @memberof UserApiUserImportStudentPost
     */
    readonly fileName?: string
}

/**
 * Request parameters for userImportStudentStatusPost operation in UserApi.
 * @export
 * @interface UserApiUserImportStudentStatusPostRequest
 */
export interface UserApiUserImportStudentStatusPostRequest {
    /**
     * 
     * @type {string}
     * @memberof UserApiUserImportStudentStatusPost
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof UserApiUserImportStudentStatusPost
     */
    readonly contentDisposition?: string

    /**
     * 
     * @type {number}
     * @memberof UserApiUserImportStudentStatusPost
     */
    readonly length?: number

    /**
     * 
     * @type {string}
     * @memberof UserApiUserImportStudentStatusPost
     */
    readonly name?: string

    /**
     * 
     * @type {string}
     * @memberof UserApiUserImportStudentStatusPost
     */
    readonly fileName?: string
}

/**
 * Request parameters for userImportTeacherPost operation in UserApi.
 * @export
 * @interface UserApiUserImportTeacherPostRequest
 */
export interface UserApiUserImportTeacherPostRequest {
    /**
     * 
     * @type {boolean}
     * @memberof UserApiUserImportTeacherPost
     */
    readonly isSupervisor: boolean

    /**
     * 
     * @type {boolean}
     * @memberof UserApiUserImportTeacherPost
     */
    readonly isJudge: boolean

    /**
     * 
     * @type {boolean}
     * @memberof UserApiUserImportTeacherPost
     */
    readonly isChecker: boolean

    /**
     * 
     * @type {string}
     * @memberof UserApiUserImportTeacherPost
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof UserApiUserImportTeacherPost
     */
    readonly contentDisposition?: string

    /**
     * 
     * @type {number}
     * @memberof UserApiUserImportTeacherPost
     */
    readonly length?: number

    /**
     * 
     * @type {string}
     * @memberof UserApiUserImportTeacherPost
     */
    readonly name?: string

    /**
     * 
     * @type {string}
     * @memberof UserApiUserImportTeacherPost
     */
    readonly fileName?: string
}

/**
 * Request parameters for userToggleTeacherTypePost operation in UserApi.
 * @export
 * @interface UserApiUserToggleTeacherTypePostRequest
 */
export interface UserApiUserToggleTeacherTypePostRequest {
    /**
     * 
     * @type {UserToggleTeacherTypeModel}
     * @memberof UserApiUserToggleTeacherTypePost
     */
    readonly userToggleTeacherTypeModel?: UserToggleTeacherTypeModel
}

/**
 * Request parameters for userUpdatePasswordPost operation in UserApi.
 * @export
 * @interface UserApiUserUpdatePasswordPostRequest
 */
export interface UserApiUserUpdatePasswordPostRequest {
    /**
     * 
     * @type {UserUpdatePasswordModel}
     * @memberof UserApiUserUpdatePasswordPost
     */
    readonly userUpdatePasswordModel?: UserUpdatePasswordModel
}

/**
 * Request parameters for userUpdateStudentInfoPost operation in UserApi.
 * @export
 * @interface UserApiUserUpdateStudentInfoPostRequest
 */
export interface UserApiUserUpdateStudentInfoPostRequest {
    /**
     * 
     * @type {StudentUpdateInfoModel}
     * @memberof UserApiUserUpdateStudentInfoPost
     */
    readonly studentUpdateInfoModel?: StudentUpdateInfoModel
}

/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
export class UserApi extends BaseAPI {
    /**
     * 
     * @param {UserApiUserDeletePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userDeletePost(requestParameters: UserApiUserDeletePostRequest = {}, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).userDeletePost(requestParameters.userFindParams, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiUserFindGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userFindGet(requestParameters: UserApiUserFindGetRequest = {}, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).userFindGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiUserGetDefaultPasswordPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userGetDefaultPasswordPost(requestParameters: UserApiUserGetDefaultPasswordPostRequest = {}, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).userGetDefaultPasswordPost(requestParameters.userGetDefaultPasswordParams, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userGetStudentExcelTemplateGet(options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).userGetStudentExcelTemplateGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userGetStudentStatusExcelTemplateGet(options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).userGetStudentStatusExcelTemplateGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userGetTeacherExcelTemplateGet(options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).userGetTeacherExcelTemplateGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiUserImportStudentPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userImportStudentPost(requestParameters: UserApiUserImportStudentPostRequest = {}, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).userImportStudentPost(requestParameters.contentType, requestParameters.contentDisposition, requestParameters.length, requestParameters.name, requestParameters.fileName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiUserImportStudentStatusPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userImportStudentStatusPost(requestParameters: UserApiUserImportStudentStatusPostRequest = {}, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).userImportStudentStatusPost(requestParameters.contentType, requestParameters.contentDisposition, requestParameters.length, requestParameters.name, requestParameters.fileName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiUserImportTeacherPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userImportTeacherPost(requestParameters: UserApiUserImportTeacherPostRequest, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).userImportTeacherPost(requestParameters.isSupervisor, requestParameters.isJudge, requestParameters.isChecker, requestParameters.contentType, requestParameters.contentDisposition, requestParameters.length, requestParameters.name, requestParameters.fileName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userListGet(options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).userListGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiUserToggleTeacherTypePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userToggleTeacherTypePost(requestParameters: UserApiUserToggleTeacherTypePostRequest = {}, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).userToggleTeacherTypePost(requestParameters.userToggleTeacherTypeModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiUserUpdatePasswordPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userUpdatePasswordPost(requestParameters: UserApiUserUpdatePasswordPostRequest = {}, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).userUpdatePasswordPost(requestParameters.userUpdatePasswordModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiUserUpdateStudentInfoPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userUpdateStudentInfoPost(requestParameters: UserApiUserUpdateStudentInfoPostRequest = {}, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).userUpdateStudentInfoPost(requestParameters.studentUpdateInfoModel, options).then((request) => request(this.axios, this.basePath));
    }
}


